import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import MaterialLinearProgress from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/LinearProgress';

const styles = (theme) => {
  return {
    root: {
      position: 'relative',
      textAlign: 'center',
    },
    rootHide: {
      display: 'none',
    },
    text: {
      width: '100%',
      position: 'absolute',
      zIndex: 10,
      top: '50%',
      transform: 'translate(-50%, -50%)',
      color: theme.palette.common.white,
    },
    progress: {
      height: theme.spacing(3),
    },
    progressForFDLButtonOverlay: {
      height: theme.spacing(4),
      borderRadius: '50px',
    },
  };
};

function LinearProgress(props) {
  const {
    classes,
    className,
    color,
    visible,
    text,
    textVariant,
    ProgressProps,
    useProgressForFDLOverlayClass,
  } = props;

  return (
    <div
      className={classNames(classes.root, className, {
        [classes.rootHide]: !visible,
      })}
    >
      {text.length > 0 && (
        <Typography
          className={classes.text}
          component="span"
          variant={textVariant}
        >
          {text}
        </Typography>
      )}
      <MaterialLinearProgress
        className={classNames({
          [classes.progressForFDLButtonOverlay]: useProgressForFDLOverlayClass,
          [classes.progress]: !useProgressForFDLOverlayClass,
        })}
        color={color}
        {...ProgressProps}
      />
    </div>
  );
}

LinearProgress.defaultProps = {
  className: '',
  text: '',
  visible: true,
  textVariant: 'h5',
  ProgressProps: {},
  useProgressForFDLOverlayClass: false,
};

LinearProgress.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  text: PropTypes.string,
  visible: PropTypes.bool,
  textVariant: PropTypes.string,
  ProgressProps: PropTypes.object,
  useProgressForFDLOverlayClass: PropTypes.bool,
};

export default withStyles(styles)(LinearProgress);
